module.exports = __webpack_public_path__ + "img/index_keyboard_border.cec3def7.png";